export const checkScroll = {
    data() {
        return {

        }
    },
    methods: {
        checkScroll() {
            let hasScrollbar;
            if (typeof window.innerWidth === 'number') {
                hasScrollbar = window.innerWidth >
                document.documentElement.clientWidth
            }

            hasScrollbar =
                hasScrollbar ||
                document.documentElement.scrollHeight >
                document.documentElement.clientHeight;

            if (hasScrollbar) {
                document.getElementsByTagName('body')[0]
                    .classList.add('scroll-fix');
            }
        },
        checkRemoveScroll() {
            if (document.querySelectorAll('.v--modal').length < 2) {
                document.getElementsByTagName('body')[0]
                .classList.remove('scroll-fix');
            }
        }
    }
}
